
import { Component, Vue } from "vue-property-decorator";
import {Getter} from "vuex-class";
import AddContact from "@/components/users/AddContact.vue";
import AddSubordinate from "@/components/users/AddSubordinate.vue";
import EditUser from "@/components/users/EditUser.vue";
import ListSelectOverlay from "@/components/list/ListSelectOverlay.vue";

@Component({
    components: {
        ListSelectOverlay,
        AddContact,
        AddSubordinate,
        EditUser,
    },
})
export default class UsersMobile extends Vue {
    private users: object[] = [];
    private loading: boolean = false;
    private pagination: any = {
        sortDesc: [false],
        sortBy: [""],
        search: "",
        page: 1,
        itemsPerPage: 10,
        totalItems: 10,
        loaded: false,
    };
    private currentTab: string = "contacts";
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    @Getter private envCompanyId: number|null;

    private mounted() {
        this.scroll();
        this.reset();
    }

    private getInfo(user , info) {
        return user.Contact && user.Contact[info] !== null && user.Contact[info] !== "" ?
            user.Contact[info] : user[info] || "";
    }

    private changeTab(tab) {
        this.pagination = {
            sortDesc: [false],
            sortBy: [""],
            search: "",
            page: 1,
            itemsPerPage: 10,
            totalItems: 10,
            loaded: false,
        };
        this.users = [];
        this.currentTab = tab;
        this.reset();
    }

    private enterKeyPress(e) {
        if (e.keyCode === 13) {
            this.reset();
        }
    }

    private reset() {
      this.pagination.page = 1;
      this.pagination.loaded = false;
      this.loading = true;
      this.users = [];
      this.fetchData(this.pagination)
        .then((res) => {
          this.users = res.users.filter(Boolean);
          this.pagination.totalItems = res.count;
        })
        .catch(((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        }))
        .finally(() => {
          this.loading = false;
        });
    }

    private fetchData(query): Promise<any> {
      switch (this.currentTab) {
        case "contacts":
          return this.getContacts(query);
        case "management":
          return this.getSubordinates(query);
        default:
          return Promise.reject();
      }
    }

    private getContacts(query: any): Promise<any> {
      if (!this.canDoInEnvCompany("READ_CONTACTS")) {
        this.$store.commit("alerts/displayError", {
          msg: this.$t("alerts.error.cantFetchUsers"),
        });
        return Promise.reject();
      }
      return this.$store.dispatch("companies/getContacts", {
        query,
        id: this.envCompanyId,
      });
    }

    private getSubordinates(query: any): Promise<any> {
      if (!this.canDoInEnvCompany("READ_SUBORDINATES")) {
        this.$store.commit("alerts/displayError", {
          msg: this.$t("alerts.error.cantFetchUsers"),
        });
        return Promise.reject();
      }
      return this.$store.dispatch("companies/getSubordinates", {
        query,
        id: this.envCompanyId,
      });
    }

    private scroll() {
        window.onscroll = () => {
            const listElm = document.querySelector("#users-list");
            if (listElm?.clientHeight <= (document.documentElement.scrollTop + window.innerHeight + 100)
                && !this.loading && !this.pagination.loaded) {
                if (this.pagination.totalItems > this.pagination.itemsPerPage) {
                    this.pagination.page += 1;
                    this.loading = true;
                    this.fetchData(this.pagination).then((res) => {
                        if (res.users.length) {
                            res.users.forEach((user) => {
                                if (typeof user === "object" && user !== null) {
                                    this.users.push(user);
                                }
                            });
                        } else {
                            this.pagination.loaded = true;
                        }
                        this.loading = false;
                    });
                }
            }
        };
    }

    private hasRight(right: string): boolean {
      return this.canDoInEnvCompany(right);
    }

}
